import type { FC } from "react";
import { IoIosClose } from "react-icons/io";
import { CartonDigitalModal } from "../CartonDigitalModal/CartonDigitalModal";
import { FotoDeTiendaModal } from "../FotoDeTiendaModal/FotoDeTiendaModal";
import { HistorialDePagosModal } from "../HistorialDePagosModal/HistorialDePagosModal";
import { useDetallesClienteModal } from "./detallesClienteModalHooks";
import type { DetallesClienteModalProps } from "./types";

export const DetallesClienteModal: FC<DetallesClienteModalProps> = (props) => {
  const modalState = useDetallesClienteModal(props);

  if (!modalState) {
    return null;
  }

  const {
    cliente,
    dataTablaHeader,
    detalleTablaRows,
    handleClose,
    handleCloseCartonDigital,
    handleCloseFotoPerfil,
    handleCloseFotoDeTienda,
    handleCloseHistorial,
    handleOpenCartonDigital,
    handleOpenFotoPerfil,
    handleOpenFotoDeTienda,
    handleOpenHistorial,
    mapUrl,
    mostrarCartonDigital,
    mostrarHistorial,
    tieneFotoPerfil,
    tieneFotoTienda,
    tieneUbicacion,
    verFotoPerfil,
    verFotoDeTienda,
  } = modalState;

  return (
    <>
      {mostrarCartonDigital ? (
        <CartonDigitalModal
          setMostrarCartonDigital={handleCloseCartonDigital}
          datos={cliente}
        />
      ) : null}

      {mostrarHistorial ? (
        <HistorialDePagosModal
          setMostrarHistorial={handleCloseHistorial}
          datos={cliente}
        />
      ) : null}

      {verFotoPerfil ? (
        <FotoDeTiendaModal
          setVerFotoDeTienda={handleCloseFotoPerfil}
          imagen={cliente.imageUrl}
        />
      ) : null}

      {verFotoDeTienda ? (
        <FotoDeTiendaModal
          setVerFotoDeTienda={handleCloseFotoDeTienda}
          imagen={cliente.imageTienda}
        />
      ) : null}

      <div className="w-full min-h-screen h-screen z-10 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
        <div className="bg-gray-200 w-[400px] p-4 rounded-md relative max-h-[90%] overflow-y-auto text-sm">
          <div className="absolute right-2 top-2 cursor-pointer bg-white rounded-[50%] p-[1px]">
            <IoIosClose size={40} onClick={handleClose} />
          </div>

          <p className="uppercase font-semibold mt-1">
            Ver foto del cliente:{" "}
            {tieneFotoPerfil ? (
              <span
                className="text-[#8131bd] font-semibold cursor-pointer"
                onClick={handleOpenFotoPerfil}
              >
                ver
              </span>
            ) : (
              <span className="font-bold">sin datos</span>
            )}
          </p>

          <p className="uppercase font-semibold mt-1">
            Cliente: <span className="font-bold">{cliente.nombreCliente || "Sin datos"}</span>
          </p>

          <p className="uppercase font-semibold">
            CPF: <span className="font-bold">{cliente.cpf || "Sin datos"}</span>
          </p>

          <p className="uppercase font-semibold">
            tlf: <span className="font-bold">{cliente.telefono || "Sin datos"}</span>
          </p>

          <p className="uppercase font-semibold text-sm whitespace-pre-line">
            direccion: <span className="font-bold">{cliente.direccion || "Sin datos"}</span>
          </p>

          <p className="uppercase font-semibold whitespace-pre-line">
            direccion de cobro: <span className="font-bold">{cliente.direccionCobro || "sin datos"}</span>
          </p>

          <p className="uppercase font-semibold mt-1 whitespace-pre-line">
            Descripcion: <span className="font-bold">{cliente.descripcion || "sin datos"}</span>
          </p>

          <p className="uppercase font-semibold mt-1">
            Ver foto de tienda:{" "}
            {tieneFotoTienda ? (
              <span
                className="text-[#8131bd] font-semibold cursor-pointer"
                onClick={handleOpenFotoDeTienda}
              >
                ver
              </span>
            ) : (
              <span className="font-bold">sin datos</span>
            )}
          </p>

          <p className="uppercase font-semibold break-all">
            ubicacion:{" "}
            {tieneUbicacion ? (
              <a
                href={mapUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#8131bd] font-semibold"
              >
                Ver en Google Maps
              </a>
            ) : (
              <span className="font-bold">sin datos</span>
            )}
          </p>

          <table className="w-full mt-2 flex">
            <thead className="w-[50%]">
              <tr className="bg-[#aa7acf] uppercase text-xs flex flex-col border border-black">
                {dataTablaHeader.map((item, index) => (
                  <th
                    key={item.titulo}
                    className={
                      index === dataTablaHeader.length - 1
                        ? " w-full px-2 py-1"
                        : "w-full border-b border-black px-2 py-1"
                    }
                  >
                    {item.titulo}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="w-[50%]">
              <tr className=" uppercase text-xs flex flex-col border-y border-r border-black">
                {detalleTablaRows.map((item, index) => (
                  <td
                    key={`${dataTablaHeader[index]?.titulo}-${index}`}
                    className={
                      index === detalleTablaRows.length - 1
                        ? "w-full px-2 py-1 text-center font-bold"
                        : "w-full border-b border-black px-2 py-1 text-center font-bold"
                    }
                  >
                    {item.valor}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
          <div className="flex w-full justify-between">
            <button
              type="button"
              className="bg-[#8131bd] mt-4 mx-auto w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
              onClick={handleOpenCartonDigital}
            >
              Carton Digital
            </button>

            <button
              type="button"
              className="bg-[#8131bd] mt-4 mx-auto w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
              onClick={handleOpenHistorial}
            >
              Historial de Pagos
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
